import React, { FC } from 'react';
import { TablePaginationConfig } from 'antd/lib/table';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import { useNavigate } from 'react-router-dom';
import useColumnConfig from './ColumnsConfig';
import { StyledTable } from './TableContent.styles';
import { ISurveyItem, ITableContent } from './TableContent.types';
import { RouteNames } from '../../../constans/routes';
import { useSurveyTable, useSort } from '../../../hooks';

const TableContent: FC<ITableContent> = ({ data, applyFilters, loading }) => {
  const { getAppliedFilters } = useSurveyTable();
  const { setSortQuery } = useSort();
  const navigate = useNavigate();
  const { status: appliedStatus, sortOrder: appliedSort } = getAppliedFilters();

  const onTableChange = (
    paggination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<ISurveyItem> | SorterResult<ISurveyItem>[]
  ) => {
    applyFilters({
      sortOrder: !Array.isArray(sorter) ? setSortQuery(sorter) : null,
    });
  };

  const columns = useColumnConfig({
    appliedStatus: appliedStatus || null,
    appliedSort: appliedSort || 'endDate:desc',
  });

  return (
    <StyledTable<ISurveyItem>
      data-testid="table-content"
      rowKey={record => record.id}
      dataSource={data}
      columns={columns}
      onChange={onTableChange}
      loading={loading}
      pagination={false}
      onRow={record => {
        return {
          onClick: () => {
            navigate(
              `${RouteNames.CreateSurvey}/${record.id}?card=contents${
                record.type === 'EFFECT' ? '&domain=internal' : ''
              }`
            );
          },
        };
      }}
    />
  );
};

export default TableContent;
